import React from 'react'
import contains from 'mout/array/contains'
import values from 'mout/object/values'
import { NavSelector, FixedSelector } from './SelectorComponents'
import { Row, } from 'reactstrap'
import getFixedSelectors from '../../../../helpers/users/manageUsers/getFixedSelectors';
import getParentRecord from '../../../../helpers/users/manageUsers/getParentRecord';


export default function Selector(props) {
  const { districts, schools, teachers, id, user, history, baseLink, selectorLevel } = props
  // all except the last in the array are fixed
  const display = {
    district: { fixed: [], selector: 'districts' },
    school: { fixed: ['districts'], selector: 'schools' },
    teacher: { fixed: ['districts', 'schools'], selector: 'teachers' },
    classes: { fixed: ['districts', 'schools', 'teachers'], selector: 'classes' },
  }

  // the last is fixed too if the user doesn't have permissions

  const selectors = display[selectorLevel]

  const allowedSelectors = {
    'Super Administrator': ['districts', 'schools', 'teachers', 'classes'],
    'District Admin': ['schools', 'teachers', 'classes'],
    'School Admin': ['teachers', 'classes'],
    'Teacher': ['classes']
  }

  let selectorFixed = false
  if (!contains(allowedSelectors[user.role], selectors.selector)) {
    selectorFixed = true
  }

  const activeRecord = props[selectors.selector][id]

  // compute array of fixed selectors
  const fixedSelectors = getFixedSelectors(selectors, activeRecord, { districts, schools, teachers })
  
  const parentRecord = getParentRecord(activeRecord, selectors.selector, { districts, schools, teachers })

  return (
    <Row className='selector'>

      {fixedSelectors.map((selector) => 
        <FixedSelector key={`fs${selector.recordType}`} name={selector.recordType}>
          {selector.name}
        </FixedSelector>
      )
      }

      {selectorFixed
        ? <FixedSelector name={selectors.selector}>
            {values(props[selectors.selector])[0].name || values(props[selectors.selector])[0].fullName}
          </FixedSelector>
        : <NavSelector
            records={props[selectors.selector]}
            id={id}
            name={selectors.selector}
            history={history}
            baseLink={baseLink}
            parentRecord={parentRecord}
          />
      }

    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/Selector.js